module.exports = __webpack_public_path__ + "img/ico06.9acc08ed.svg";